module.exports = __webpack_public_path__ + "img/load.03b53bc8.gif";